// extracted by mini-css-extract-plugin
module.exports = {"disabled":"DownloadLink__disabled--1y-"};